/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */

define('modules/GiftCards/GiftCards.Service',[
    'jquery',
    'global/all',
    'plugins/jquery.proxyRequest'
], function ($, Roc) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;

    function checkCardBalance(request) {
        return $.proxyRequest({
            url: apiUrl + '/api/payment/check-gift-card-balance',
            data: JSON.stringify(request),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('GiftCards -> checkCardBalanceEvent');
                Roc.Logger.info(xhr);
            }
        });
    };

    function submitPayment(request) {
        return $.proxyRequest({
            url: '/api/payment/associate-gift-card-payment-to-order',
            data: JSON.stringify(request),
            type: 'PUT',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('GiftCards -> submitPaymentFormEvent');
                Roc.Logger.info(xhr);
            }
        });
    }


    function removeGiftCardPayment(request) {
        return $.proxyRequest({
            url: '/api/payment/delete-gift-card-payment',
            data: JSON.stringify(request),
            type: 'DELETE',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) {
                Roc.Logger.info('GiftCards -> removeGiftCardPaymentEvent');
                Roc.Logger.info(xhr);
            }
        });
    }


    var GiftCardsService = {
        checkCardBalance: checkCardBalance,
        submitPayment: submitPayment,
        removeGiftCardPayment: removeGiftCardPayment
    };

    Roc.Logger.debug('GiftCards.Service.js Loaded:', GiftCardsService);
    return GiftCardsService;
});
